export abstract class AActivityIcon {
  public ActivityTypeId: string;
  public ActivityTypeName: string;
  public ActivityTypeIconNumber: number;
  public IsRemedial: boolean;
}
